import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import Checkbox from '@mui/material/Checkbox'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { setReduxValue } from 'src/redux/slices/eLearning/enroll'
import { handleOpenDialog } from './events'
import { Column, Row } from 'src/components/Layout/Styled'

const Consent = () => {
  const consent = useSelector(
    (state) => state.eLearningEnroll.consent,
    shallowEqual
  )
  const dispatch = useDispatch()
  const [checkConsent, setCheckConsent] = useState(consent)

  useEffect(() => {
    dispatch(setReduxValue({ index: 'consent', value: checkConsent }))
  }, [checkConsent])

  return (
    <Column sx={{ gap: 3, mt: 1 }}>
      <Row sx={{ alignItems: 'flex-start', mt: 1 }}>
        <Checkbox
          onChange={(e) => setCheckConsent(e.target.checked)}
          name="consent"
          checked={checkConsent}
          sx={{ mt: -1.25, ml: -1 }}
        />
        <Typography>
          ยอมรับ{' '}
          <Link
            component="span"
            onClick={() => dispatch(handleOpenDialog('consentBodyText'))}
          >
            นโยบายคุ้มครองข้อมูลส่วนบุคคล
          </Link>
          สำหรับการอบรมเก็บชั่วโมงออนไลน์หลักสูตรระดับสูงและ
          <Link
            component="span"
            onClick={() => dispatch(handleOpenDialog('TERMS_AND_CONDITIONS_'))}
          >
            ข้อตกลงและเงื่อนไขการใช้งาน
          </Link>
        </Typography>
      </Row>
    </Column>
  )
}

export default Consent
